import React from "react";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";

export default function Rating({ rating, totalReviews }) {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    return (
        <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "1.5rem", fontWeight: "bold" }}>{rating}</div>
            <div style={{ color: "#FFA500", fontSize: "1.1rem" }}>
                {Array(fullStars).fill(<FaStar />)}
                {hasHalfStar && <FaStarHalfAlt />}
                {Array(emptyStars).fill(<FaRegStar />)}
            </div>
            <div style={{ color: "gray", fontSize: "0.5rem" }}>
                ({totalReviews.toLocaleString()})
            </div>
            <div style={{ color: "gray", fontSize: "0.5rem" }}>
                opiniones en Google
            </div>
        </div>
    );
}